import Tree from './Tree';
import TreeNode from './TreeNode';
Tree.TreeNode = TreeNode;

export default Tree;
